export class ConstantesService {
  /* Version */
  public static VERSION_FRONT = "0.85";

  /* TEMAS DE APLICACIÓN*/

  public static temaRosado = "rosa-fucsia";
  public static temaAzul = "yeti";
  public static temaNegro = "dark-white";
  public static temaGris = "gris-blanco";

  public static MESES = new Array(
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre"
  );
  public static DIAS_SEMANA = new Array(
    "Domingo",
    "Lunes",
    "Martes",
    "Miércoles",
    "Jueves",
    "Viernes",
    "Sábado"
  );

  public static MSJ_CONFIRM_REGISTRO_CODIGO_TARJETA =
    "¿Está seguro de asociar tarjeta y registrar ingreso?";
  public static MSJ_CONFIRM_REGISTRO_SALIDA =
    "¿Está seguro de registrar salida?";
  public static MSJ_CONFIRM_REGISTRO_SAL_PARCIAL =
    "¿Está seguro de registrar salida parcial?";
  public static MSJ_CONF_RGISTR_SAL_PARCIAL_SIN_ACTIV =
    "¿Está seguro de registrar salida, sin reitrar activo ingresado?";
  public static MSJ_CONF_SAL_SIN_STICKER =
    "¿Está seguro de registrar salida sin entrega de sticker/Tarjeta?";
  public static MSJ_CONF_CREAR_CODIGOS_TARJETAS =
    "¿Está seguro de crear códigos y generar PDF para tarjetas reutilizables?";
  public static MSJ_CONF_CREAR_CODIGOS_STICKERS =
    "¿Está seguro de crear códigos para stickers?";
  public static MSJ_CONF_EDITAR_CODIGOS_TARJETAS_SIN_PDF =
    "¿Está seguro de cambiar el estado para el(los) código(s) de tarjeta?";
  public static MSJ_CONF_EDITAR_CODIGOS_TARJETAS_CON_PDF =
    "¿Está seguro de cambiar el estado y generar PDF de tarjeta para el(los) código(s) de tarjeta seleccionado(s)";
  public static MSJ_CONF_EDITAR_CODIGOS_STICKERS =
    "¿Está seguro de cambiar el estado para el(los) código(s) de stickers?";
  public static MSJ_CONF_REPROGRAMAR_AGENDA_VITUAL =
    "¿Está seguro de reprogramar el turno virtual?";
  public static MSJ_CONF_CANCELAR_AGENDA_VITUAL =
    "¿Está seguro de cancelar el turno virtual?";
  public static MSJ_CONF_GENERAR_TURNO =
    "¿Está seguro de generar turno con la información ingresada para el ciudadano?";
  public static MSJ_CONF_GUARDAR_FUNCIONARIO =
    "¿Está seguro de guardar la información ingresada para el funcionario?";
  public static MSJ_CONF_GUARDAR_COMPENSACION =
    "¿Está seguro de guardar la parametrización ingresada?";
  public static MSJ_CONF_GUARDAR_JEFE =
    "¿Está seguro de crear la relación dependencia jefe?";
  public static MSJ_CONF_GUARDAR_SEDE =
    "¿Está seguro de guardar la relación dependencia sede?";

  public static VISITANTES = "VISITANTES";
  public static VISITANTES_CON_AGENDA = "VISITANTES CON AGENDA";
  public static RESULTADO_DE_BUSQUEDA = "RESULTADO DE BUSQUEDA";
  public static VISITAS_ACTIVAS = "VISITAS ACTIVAS";

  public static SUBTIULO_VISITANTES =
    "Listado de personas que tienen agenda hoy.";
  public static SUBTITULO_VISITANTES_CON_AGENDA =
    "Listado de personas con agendas.";
  public static SUBTITULO_UN_RESULTADO = "Se encontró un resultado.";
  public static SUBTITULO_ACTIVOS =
    "Listado de personas que se encuentran en visita.";
  public static SUBTITULO_NO_ENCONTRADO_VIGILANTE =
    "No se encontró resultado de visita programada con los datos ingresados.";
  public static SUBTITULO_NO_ENCONTRADO_PREAUTORIZADOR =
    "No se encontró un resultado.";

  public static SUBTITULO_DOS_VIGILANTE =
    "Intente usar otra opción de busqueda, como nombre o número de documento";
  public static SUBTITULO_DOS_PREAUTORIZADOR =
    "Intente usar otra opción de busqueda, como nombre o número de documento o cree nuevo visitante";

  public static BANDERA_ROL_VIGILANTE = "Vigilante";
  public static BANDERA_ROL_PREAUTORIZADOR = "Preautorizador";
  public static ESTADO_ACTIVO_FIJO_VALOR_NO_REGISTRA_ENTRADA =
    "NO REGISTRA ENTRADA";
  public static ESTADO_ACTIVO_FIJO_VALOR_NO_REGISTRA_SALIDA =
    "NO REGISTRA SALIDA";

  public static PANTALLA_INGRESO_SALIDA_FUNCIONARIO = "Funcionarios";
  public static PANTALLA_INGRESO_SALIDA_VISITANTE_ENTRADA =
    "Visitantes-Entrada";
  public static PANTALLA_INGRESO_SALIDA_VISITANTE_SALIDA = "Visitantes-Salida";

  /**
   * MENSAJES CU_20
   */
  public static REGISTRO_ACTIVO_FIJO_VISITANTE_EXISTOSO =
    "Se registró el elemento exitosamente";

  /* Gestor de Archivos  */
  // tslint:disable-next-line: max-line-length
  public static SIN_ADJUNTO =
    "No se ha cargado ningún archivo. Seleccione la opción cargar archivo y la opción registrar visita para programar visitas a los visitantes incluidos en el archivo";
  public static SIN_ADJUNTO_INVENTARIO =
    "No se ha cargado ningún archivo. Seleccione la opción cargar archivo y la opción registrar";
  public static SELECCIONAR_ARCHIVO = "Seleccione Archivo";

  // Constantes Servicios SIA3
  public static AUTENTICACION_RESOURCE =
    "recursoswebseguridad/servicios/autenticacion";
  public static TOKEN_RESOURCE = "/obtenertoken";
  public static ROLES_PERMISOS_RESOURCE = "/obtenerrolespermisos";

  public static USER_ID_HEADER = "usuario";
  public static NUMBER_HEADER = "numeroDocumento";
  public static TOKEN_HEADER = "Token";
  public static TOKEN_EXP_DATE_HEADER = "expiracionToken";
  public static LANGUAGE_HEADER = "idioma";
  public static SESSION_CONTEXT = "session-context";

  public static HTML_STICKER =
    '<html><head></head><body><style>@media print {#visitante {background-color: #bbb !important;-webkit-print-color-adjust: exact; }} body {margin: 0; margin-top: 10mm;}.align-center{text-align: center}.letra-gruesa{font-weight: bold;}.distribution{display: inline-flex;padding: .2em;}.columna-izq{width: 20%;border: 1px white solid;}.columna-der{width: 75%;border: 1px white solid;}.vertical{writing-mode: vertical-rl;text-orientation: upright}.titulo{font-size: 13px;}#datos>p{margin: 0; margin-top: 1px; margin-bottom: 1px}.sub-titulo{font-size: 11px;}.primera-agenda{font-size: 13px}.dependencias{font-size: 12px;font-weight: bold;white-space: nowrap;}.footer{font-size: 11px}.detalle{font-size: 7px;}@page{size: 58mm 100mm;margin: 0}</style><div class="distribution"><div class="align-center columna-izq"> <img src="[logoministerio]" width="50%" style="margin-top: 15%;max-height: 25px;margin-left: 20%;"><p class="detalle">MINEDUCACIÓN</p><div class="vertical " style="font-size: 20px;margin-top: 25px;"><p style="margin: 0 12px;" id="visitante">VISITANTE</p></div></div><div class="columna-der"><div class="align-center"> <img src="[fotovisitante]" style="max-width: 80%; height: 90px"></div><div id="datos" class="align-center"><p class="titulo letra-gruesa">[nombres]</p><p class="sub-titulo letra-gruesa">[documentoIdentificacion]</p><p class="sub-titulo letra-gruesa">Autorizado por:</p>[autorizadoPor]<p class="sub-titulo letra-gruesa">Sede: [sede]</p><img src="[codigobarras]" style="width: 60%; max-width: 100%; max-height: 60px"><p class="footer">[ingreso]</p><p class="footer">Ingresa Activo Fijo:</p><p style="border-bottom: 1px solid" class="sub-titulo">[activoFijo]</p></div></div></div></body></html>';
  /**
   * Constantesd de mensaje en CU 023 cancelar agenda masiva
   */
  public static INSTRUCCION_USO =
    "Seleccione la fecha y el archivo con el que se crearon las visitas que se van a cancelar";
  public static MENSAJE_EXCEPCION_NO_ARCHIVOS_EN_FECHA =
    "No existen archivos de creación masiva de agendas para la fecha seleccionada";
  public static PLACEHOLDER_DATE_PICKER =
    "Seleccione fecha de creación de visitas";
  public static SELECCION_FECHA = "Seleccione fecha";
  public static PLACEHOLDER_NOMBRE_ARCHIVO =
    "Seleccione archivo con el que se crearon las visitas";

  // Mensajes modales de confirmaciòn CU_010 y CU_009

  public static FILTRO_ACTIVOS_NO_ENCONTRADO =
    "Los criterios buscados no se encuentran asociados a ningún Activo Fijo del MEN registrado" +
    ", por favor verifique la información ingresada e intente nuevamente";
  public static CONFIRMACION_INGRESO_ACTIVO =
    "¿Está seguro de ingresar elemento?";
  public static CONFIRMACION_RETIRO_ACTIVO =
    "¿Está seguro de retirar elemento?";
  public static CONFIRMACION_RETIRO_ACTIVO_NO_PROPIO =
    "El activo consultado no se encuentra asignado al funcionario que está gestionando el retiro ¿desea continuar?";
  public static FILTRO_ACTIVOS_RECIENTES_VACIO_MEN =
    "Los criterios buscados no se encuentran asociados a ningún Activo Fijo del MEN registrado, " +
    "por favor verifique la información ingresada e intente nuevamente";
  public static FILTRO_ACTIVOS_RECIENTES_VACIO_PROPIO =
    "Los criterios buscados no se encuentran asociados a ningún Activo Fijo propio registrado, " +
    "por favor verifique la información ingresada e intente nuevamente";
  public static ACTIVO_EXITENTE_EN_SISTEMA =
    "El activo ya se encuentra registrado en el sistema";
  public static ACTIVO_NO_EXITENTE_EN_SISTEMA =
    "El activo no se encuentra registrado en el sistema";

  public static PLACEHOLDER_NUMERO_SERIAL = "Incluya número de serial*";
  public static PLACEHOLDER_TIPO_ACTIVO = "Digite el tipo de activo";
  public static OPCION_CUAL = "Otro";
  public static VALOR_CUAL = "cual";

  // Session Storage
  public static USUARIO_SESSSION = "Usuario";
  public static ROL_SESSION = "Rol";
  public static ROL_SESSION_SIA3 = "RolSia3";
  public static NOMBRE_SESSION = "Nombre";
  public static TIPO_DOC_SESSSION = "tipoDocumento";
  public static NUM_DOC_SESSSION = "numDocumento";
  public static SEDE_SESSSION = "sedeSession";
  public static SIA3_SESSSION = "sia3Session";
  public static FTP_SESSSION = "ftpSession";
  public static TIEMPO_ACCESIBILIDAD_SESSION = "tiempoAccesibilidad";
  public static SEDE_DEFECTO_SESSSION = "sedeDefectoSession";

  public static ROL_VALOR_VIGILANTE = "Vigilante";
  public static ROL_VALOR_PREAUTORIZADOR = "Preautorizador";

  public static readonly OPC_SELECT = "opcSelect";

  /**
   * CONSTANTES CU_003
   */
  public static MSG_AGENDA_FECHAS_MULTIPLE_ERROR =
    "La fecha de inicio de agenda es mayor a la fecha de fin";
  public static MSG_AGENDA_CREADA_POR_OTRO_PREAUT =
    "No se puede actualizar la información del visitante porque el visitante tiene una visita creada por otro Preautorizador";
  public static MSG_AGENDA_ESTADO_NO_EDITABLE =
    "No se puede actualizar la información del visitante porque tiene registrada " +
    "una visita con un estado no permitido para editar información";
  public static MSG_AGENDA_CREADA_EXITO = "La visita se ha creado exitosamente";
  public static MSG_PARQUEADERO_VERIFICACION =
    "El cupo para el parqueadero está sujeto a verificación.";
  public static MSG_ACTUALIZACION_AGND_CORRECTA =
    "Se actualizó la información del visitante correctamente";

  public static BTN_BICI = "btn-BICI";
  public static BTN_CARRO = "btn-CAR";
  public static BTN_MOTO = "btn-MOTO";
  public static BTN_OTRO = "btn-OTRO";
  public static BTN_NO = "btn-NO";

  public static mensajeConfirmacionCambioTramiteUAC =
    "Se cambió de trámite exitosamente";
  public static mensajeConfirmacionAbandonoUAC =
    "Se registró abandono de turno exitosamente";
  public static mensajeConfirmacionVentanillaEspera =
    "Se registró suspensión de atención en ventanilla exitosamente";

  public static TRAMITE_FUNCIONARIO = "Atención Funcionario";
  public static ID_TRAMITE_FUNCIONARIO = "6";
  public static MOTIVO_PRIORIDAD_DISCAPACIDAD = "";

  public static FORMATO_FECHA_ISO = "YYYY-MM-DD";

  // Para dominios utilizar DominiosService

  public static TIEMPO_MENSAJE_PANTALLA_TURNOS =
    "TIEMPO_MENSAJE_PANTALLA_TURNOS";
  public static MENSAJE_PANTALLA_TURNOS = "MENSAJE_PANTALLA_TURNOS";

  public static ESTADO_TRAMITE_ACTIVO = "ACT";
  public static ESTADO_CONFIGURACION_VENTANILLA_ACTIVO = "ACT";

  // Mensajes CU001C - Configurar ventanillas
  public static MSG_CONFIRMACION_CONFIGURAR_VENTANILLA =
    "¿Está seguro de guardar información para la ventanilla?";
  public static MSG_ERROR_CONFIGURAR_VENTANILLA =
    "Error al guardar la información de la ventanilla";

  public static ESTADO_TURNO_EN_TRAMITE = "EN_TRAMITE";
  public static ESTADO_TURNO_LLAMADO = "LLAMADO";

  // Constantes CU001 Configurar UAC
  public static TRAMITE_UAC = "Servicio";
  public static VENTANILLA_UAC = "Ventanilla";
  public static MOTIVO_CONSULTA = "Motivo de consulta";
  public static MSG_CONFIRMACION_GUARDAR_PARAMETRO =
    "¿Está seguro de guardar información para el parámetro?";

  // PARAMETROS TALANQUERA CODIGOS

  public static TIEMPO_DURACION_ALERTA_TALANQUERA =
    "TIEMPO_DURACION_ALERTA_TALANQUERA";
  public static ESTADO_AGENDA_ACTIVA_CON_ACTIVO = "ACT_CON";
  public static REPORTE_SIN_DATA =
    "No existe información registrada para el reporte seleccionado, por favor intente nuevamente";

  // public static MENSAJE_INGRESO_TALANQUERA = 'MENSAJE_INGRESO_TALANQUERA';
  // public static MENSAJE_GESTION_ACTIVO_TALANQUERA = 'MENSAJE_GESTION_ACTIVO_TALANQUERA';
  // public static MENSAJE_SALIDA_TALANQUERA = 'MENSAJE_SALIDA_TALANQUERA';
  // public static MENSAJE_CODIGO_INEXST_TALANQUERA = 'MENSAJE_CODIGO_INEXST_TALANQUERA';
  // public static MENSAJE_VISITA_INVLD_TALANQUERA = 'MENSAJE_VISITA_INVLD_TALANQUERA';

  // ESC2 CU003 - Inscripción plan compensación
  public static MENSAJE_CONFIRMACION_INSCRIPCION_COMPENSACION =
    "¿Está seguro de realizar inscripción al plan de compensación?";
  public static MENSAJE_EXITO_INSCRIPCION_COMPENSACION =
    "Se realizó inscripción exitosamente";
  public static MENSAJE_ERROR_INSCRIPCION_COMPENSACION =
    "Error al realizar inscripción";
  public static MENSAJE_NO_EXISTE_PLAN_COMPENSACION =
    "No existen planes de compensación para realizar inscripción";
  public static MENSAJE_INSCRIPCION_PLAN_COMENSACION_FINAL =
    "No se puede inscribir nuevamente a plan de compensación, por favor verifique con el jefe de área";

  // ESC2 CU003A - Aprobación inscripciones plan de compensación
  public static MENSAJE_CONFIRMACION_APROBACION_INSRIPCION =
    "¿Está seguro de aprobar inscripción al plan de compensación?";
  public static MENSAJE_EXITO_APROBACION_INSCRIPCION =
    "Se realizó aprobación exitosamente";
  public static MENSAJE_CONFIRMACION_DEVOLUCION_INSRIPCION =
    "¿Está seguro de devolver inscripción al plan de compensación?";
  public static MENSAJE_EXITO_DEVOLUCION_INSCRIPCION =
    "Se realizó devolución exitosamente";
  public static MENSAJE_CONFIRMACION_RECHAZO_INSRIPCION =
    "¿Está seguro de rechazar inscripción al plan de compensación?";
  public static MENSAJE_EXITO_RECHAZO_INSCRIPCION =
    "Se realizó rechazo exitosamente";
  public static MENSAJE_NO_EXISTEN_SOLICITUDES_APROBAR =
    "No existen planes de compensación para aprobar";
  public static MENSAJE_OBSERVACION_OBLIGATORIA_INSCRIPCION =
    "Para rechazo y devolución se deben diligenciar las observaciones, por favor verifique";
  public static MENSAJE_ERROR_ACTUALIZACION_ESTADO_INSCRIPCION =
    "Error al actualizar la inscripción";

  // ESC2 CU006 - Solicitud ajuste plan compensación
  public static MENSAJE_CONFIRMACION_SOLICITUD_AJUSTE =
    "¿Está seguro de realizar solicitud de ajuste de compensación?";
  public static MENSAJE_EXITO_SOLICITUD_AJUSTE =
    "Se realizó solicitud de ajuste exitosamente";
  public static MENSAJE_OBSERVACION_OBLIGATORIA_AJUSTE =
    "Para solicitud de ajuste se deben cargar soportes y diligenciar las observaciones, por favor verifique";
  public static MENSAJE_ERROR_SOLICITUD_AJUSTE =
    "Error al realizar solicitud de ajuste";
  public static MENSAJE_NO_EXISTEN_SOLICITUDES_AJUSTAR =
    "No existen solicitudes de ajuste para planes de compensación";

  //ESC2 CU006 - Lista solicitudes de ajuste por dependencia
  public static MENSAJE_NO_HAY_DATOS_BUSQUEDA_SOLICITUD_AJUSTE =
    "El funcionario consultado no se encuentra registrado en el sistema o no pertenece a su dependencia, por favor verifique";

  // ESC2 CU003B - Aprobar ajustes planes compensación
  public static MENSAJE_CONFIRMACION_APROBAR_AJUSTE =
    "¿Está seguro de aprobar el ajuste al plan de compensación?";
  public static MENSAJE_EXITO_APROBAR_AJUSTE =
    "Se realizó aprobación exitosamente";
  public static MENSAJE_CONFIRMACION_RECHAZAR_AJUSTE =
    "¿Está seguro de rechazar el ajuste al plan de compensación?";
  public static MENSAJE_EXITO_RECHAZAR_AJUSTE =
    "Se realizó rechazo exitosamente";
  public static MENSAJE_OBSERVACION_OBLIGATORIA_APROBACION_AJUSTE =
    "Para aprobación se debe ingresar la cantidad de horas a compensar, por favor verifique";
  public static MENSAJE_OBSERVACION_OBLIGATORIA_RECHAZO_AJUSTE =
    "Para rechazo se deben diligenciar las observaciones, por favor verifique";

  //Mensaje solicitud incentivo bicicleta
  public static MSJ_SOL_INCENTIVO_BICICLETA =
    "¿Está seguro de solicitar su dia de compensación?";
  public static MSJ_APRO_INCENTIVO_BICICLETA =
    "¿Está seguro de aprobar el dia de compensación del funcionario?";

  // SERVICIOS DE SEGURIDAD SDK
  public static ACCESS_TOKEN = "access_token";
  public static CLIENT_ID = "client_id";
  public static USER_ID = "user_id";
  public static HEADER_ID_APLICACION = "idAplicacion";

  public static LISTA_RUTAS_EXCLUIDAS = [
    "agenda-virtual",
    "tablero-turnos",
    "captura-codigo-publica",
    "cargar-foto-arl",
  ];

  // Mensajes CU001B
  public static MENSAJE_CONFIRMACION_ELIMINAR_VEHICULO =
    "¿Está seguro de eliminar vehículo?";

  public static CANTIDAD_MAXIMA_CODIGOS_STICKERS_TARJETAS = "CANTMAXCODSTITAR";
  public static TIPO_CODIGO_STICKER = "TIPO_CODIGO";

  //Constantes de accesibilidad
  public static ACCESIBILIDAD_SESSION = "SESSION_ACCESIBILIDAD";
  public static ACCESIBILIDAD_TECLADO_DEFECTO = false;
  public static ACCESIBILIDAD_LENGUAJE_DEFECTO = false;
  public static ACCESIBILIDAD_TAMANIO_LETRA = 100;
  public static ACCESIBILIDAD_TIEMPO_MENSAJE = 5;
  public static ACCESIBILIDAD_TIEMPO_GUARDADO_DEFECTO = "5";

  //Constantes de agendamiento virtual
  public static NOMBRE_PARAMETRO_FECHA_INICIAL =
    "FECHA_INICIAL_AGENDAMIENTO_VIRTUAL";
  public static NOMBRE_PARAMETRO_FECHA_FINAL =
    "FECHA_FINAL_AGENDAMIENTO_VIRTUAL";
  public static NOMBRE_PARAMETRO_TIPO_ENTRADA_TOTEM = "TIPO_ENTRADA_TOTEM";

  /**
   * Método que realiza la descarga de un archivo
   * @param tipoDocumento consultar : https://en.wikipedia.org/wiki/Media_type
   */
  public;
  static descargarDocumento(
    tipoDocumento: string,
    nombreDocumento: string,
    base64: string
  ) {
    const a = document.createElement("a");
    document.body.appendChild(a);
    a.style.cssText = "display: none";
    a.href = "data:" + tipoDocumento + ";base64," + base64;
    a.download = nombreDocumento;
    a.click();
  }
}
